import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FieldMetaData } from '../../core/gb-api/model/fieldMetaData';

@Directive({
  selector: '[appPermission]'
})
export class PermissionDirective {
  @Input('appPermission')
  set metaData(fieldMetaData: FieldMetaData) {
    if (!fieldMetaData) {
      return;
    }
    this.viewContainer.clear();
    if (fieldMetaData.access !== 'NONE') {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}
}
